/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetHouseInfoWebRequest, TGetHouseInfoWebModel, IMappers, TGetHouseInfoWebResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IHouseInfoResponseV2 } from '../../entities/house_info/HouseInfoResponseV2';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetHouseInfoWebModel(parameters: IGetHouseInfoWebRequest): TGetHouseInfoWebModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'price-estimator',
    pathApi: '/v2/get-house-info-web/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetHouseInfoWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetHouseInfoWebRequest;
}

export async function fetchGetHouseInfoWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetHouseInfoWebOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetHouseInfoWebResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetHouseInfoWebModel(parameters),
    config,
  )) as FetchResponse<TGetHouseInfoWebResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IHouseInfoResponseV2, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetHouseInfoWebResponse>;
}
